export default __webpack_public_path__ + "static/media/tarra-picturemark-l.87cf08bd.svg";